import styled from "styled-components";
import PayImage from "../../images/pay.jpg"

export const PizzaWrapper = styled.div`
width: 50vw;
height: 80vh;
background-image: url(${PayImage});
background-position: center;
background-repeat: no-repeat;
background-size: cover;
display: flex;
flex-direction: column;
align-items: center;
justify-content: center;
align-self: center;
padding-top: 10px;
font-family: poppins;
gap: 10px;

@media (max-width: 1024px){
    height: 70vh;
    width: 80%;
}
@media (max-width: 768px){
    height: 50vh;
    width: 60%;
}
@media (max-width: 600px){
    width: 90%;
}
@media (max-width: 425px){
    width: 90%;
}
`;
export const PizzaHeader = styled.div`
display: flex;
justify-content: center;
align-items: center;
font-size: 26px;
font-weight: 700;
color: #ffffff;
// color: #0E8FD8;
border-radius: 4px;
// background-color: rgba(241,255,241,0.4);
text-shadow: -1px -1px 0 #000, 1px -1px 0 #000, -1px 1px 0 #000, 1px 1px 0 #000;


@media(max-width: 768px) {
    color: #ffffff;
    text-shadow: -1px -1px 0 #000, 1px -1px 0 #000, -1px 1px 0 #000, 1px 1px 0 #000;
    width: 80%;
    font-size: 16px;
    font-weight: 700;
    // background-color: rgba(241,255,241,0.6);
}

@media(max-width: 375px) {
    width: 100%;
}
`;
export const PizzaCard = styled.div`
width: 50%;
height: 200px;
// background-color: #ffffff;
background-color: rgba(241,255,241,0.6);
// background-color: rgba(0,255,0,0.5);
display: flex;
flex-direction: column;
align-items: center;
align-self: center;
justify-content: center;
border-radius: 5px;
gap: 10px;
box-shadow: rgba(0, 0, 0, 0.18) 0px 2px 4px;
padding-top: 10px;
padding-bottom: 10px;

@media(max-width: 768px) {
    width: 90%;
}
`;
export const Row1 = styled.div`
border-bottom: 1px solid #0E8FD8;
width: 80%;
display: flex;

@media(max-width: 320px) {
    width: 90%;
}
`;
export const RowLight = styled.div`
color: #0E8FD8;
font-weight: 300;
text-transform: capitalize;
margin-right: 10px;
font-family: 12px;
`;
export const RowBold = styled.div`
color: #0E8FD8;
font-weight: 700;
text-transform: uppercase;
font-family: 14px;
`;
// export const PizzaWrapper, PizzaHeader, PizzaCard, Row1, RowLight, RowBold = styled.div``;
// export const PizzaWrapper, PizzaHeader, PizzaCard, Row1, RowLight, RowBold = styled.div``;
